import { useQuery } from '@apollo/client/react'
import { Heading } from '../base/heading'
import { Text } from '../base/text'
import { PulseLoader } from 'react-spinners'
import { graphql } from '@/gql'

const DashboardStatsQuery = graphql(`
  query DashboardStats {
    devices { count }
    equipment { count }
    successfulSyncs: testResultSyncs(filters: { stateEq: succeeded }) { count }
    pendingSyncs: testResultSyncs(filters: { stateEq: pending }) { count }
    processingSyncs: testResultSyncs(filters: { stateEq: processing }) { count }
    failedSyncs: testResultSyncs(filters: { stateEq: failed }) { count }
    passedTests: testResults(filters: { processedEq: true, resultEq: passed }) { count }
    failedTests: testResults(filters: { processedEq: true, resultEq: failed }) { count }
  }
`)

export const Stats = () => {
  const { data, loading } = useQuery(DashboardStatsQuery)

  return (
    <div className="grid grid-cols-4 gap-6">
      <div className="bg-zinc-800 border border-zinc-700 rounded-xl p-6 flex flex-col items-center justify-between gap-3">
        <Heading level={ 3 } size="xl">Devices</Heading>
        { loading ? <PulseLoader color="lightgray" size={ 12 } /> : <Heading level={ 2 } size="4xl">{ data?.devices.count }</Heading> }
      </div>
      <div className="bg-zinc-800 border border-zinc-700 rounded-xl p-6 flex flex-col items-center justify-between gap-3">
        <Heading level={ 3 } size="xl">Equipment</Heading>
        { loading ? <PulseLoader color="lightgray" size={ 12 } /> : <Heading level={ 2 } size="4xl">{ data?.equipment.count }</Heading> }
      </div>
      <div className="bg-zinc-800 border border-zinc-700 rounded-xl p-6 flex flex-col items-center justify-between gap-3">
        <Heading level={ 3 } size="xl">Syncs</Heading>
        {
          loading
            ? <PulseLoader color="lightgray" size={ 12 } />
            : <div className="flex flex-row w-full justify-around gap-1.5 text-center">
              <div>
                <Text>Successful</Text>
                <Heading level={ 2 } size="3xl">{ data?.successfulSyncs.count }</Heading>
              </div>
              <div>
                <Text>Processing</Text>
                <Heading level={ 2 } size="3xl">{ data?.processingSyncs.count }</Heading>
              </div>
              <div>
                <Text>Pending</Text>
                <Heading level={ 2 } size="3xl">{ data?.pendingSyncs.count }</Heading>
              </div>
              <div>
                <Text>Failed</Text>
                <Heading level={ 2 } size="3xl">{ data?.failedSyncs.count }</Heading>
              </div>
            </div>
        }
      </div>
      <div className="bg-zinc-800 border border-zinc-700 rounded-xl p-6 flex flex-col items-center justify-between gap-3">
        <Heading level={ 3 } size="xl">Tests</Heading>
        {
          loading
            ? <PulseLoader color="lightgray" size={ 12 } />
            : <div className="flex flex-row w-full justify-around gap-1.5 text-center">
              <div>
                <Text>Passed</Text>
                <Heading level={ 2 } size="3xl">{ data?.passedTests.count }</Heading>
              </div>
              <div>
                <Text>Failed</Text>
                <Heading level={ 2 } size="3xl">{ data?.failedTests.count }</Heading>
              </div>
            </div>
        }
      </div>
    </div>
  )
}
